module.exports = __webpack_public_path__ + "u.no1.14d12e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/u.no1.jpg
// module id = yxFZ
// module chunks = 0